import LikesApi from '../api/LikesApi';
import LikesConstants from '../constants/LikesConstants';

export function addLike({ contentId, postSuccess }) {
  return {
    types: [LikesConstants.ADD_LIKE_REQUEST, LikesConstants.ADD_LIKE_SUCCESS, LikesConstants.ADD_LIKE_FAILURE],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) =>
      LikesApi.addLike(
        {
          contentId
        },
        client
      ),
    postSuccess
  };
}

function removeLikeSuccess(id) {
  return {
    deletedEntities: [`ugc.likes.${id}`]
  };
}

export function removeLike({ id, contentId, postSuccess }) {
  return {
    types: [LikesConstants.REMOVE_LIKE_REQUEST, LikesConstants.REMOVE_LIKE_SUCCESS, LikesConstants.REMOVE_LIKE_FAILURE],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) =>
      LikesApi.removeLike(
        {
          contentId
        },
        client
      ),
    apiSuccess: () => removeLikeSuccess(id),
    postSuccess
  };
}

export default { addLike, removeLike };
